
import { Component, Vue } from "vue-property-decorator";
import api from "../../network/api";
import { Avatar } from "@/models/Avatar";
import { AxiosResponse } from "axios";

@Component
export default class UserProfilePage extends Vue {
  private username = "";
  private firstname = "";
  private lastname = "";
  private email = "";
  private avatar: any = {};

  /**
   * Retrieve User Data before Page Finishes Loading
   * @return Json
   */
  created() {
    api
      .get("user/profile", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
      .then((response: AxiosResponse) => {
        this.username = response?.data?.user?.username;
        this.firstname = response?.data?.user?.first_name;
        this.lastname = response?.data?.user?.last_name;
        this.email = response?.data?.user?.email;
        this.avatar = response?.data?.user?.avatar;

        if (this.avatar == null) {
          this.avatar = {
            avatar: "/img/user_img_placeholder.svg"
          };
        }
      });
  }

  gohome() {
    this.$router.push("/");
  }

  editProfilePicture() {
    this.$router.push("/useravatar");
  }
}
